import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import { updateDraftQuoteByIdApi } from 'api/quote';


interface EditQuoteNameDialogProps {
  isOpen: boolean;
  onClose: (arg: boolean) => void;
  quote: IDraftQuote;
}

const EditQuoteNameDialog: React.FC<EditQuoteNameDialogProps> = ({
  isOpen,
  onClose,
  quote
}) => {
  const dispatch = useDispatch();
  const [quoteName, setQuoteName] = useState(quote.name);

  const handleEditName = () => {
    onClose(false);

    const updatedDraftQuote = {
      ...quote,
      name: quoteName
    };
    updateDraftQuoteByIdApi({dispatch, updatedDraftQuoteId: quote._id, updatedDraftQuote});
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => onClose(false)}
      aria-labelledby="quote-notes-dialog"
      PaperProps={{
        className: 'border-radius-6 p-3'
      }}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogTitle id="quote-notesfirst-dialog" className="flex-column w-full p-3">
        <div className="flex justify-between">
          <Typography variant="h5" className="mb-0">
            Edit Quote Name
          </Typography>
          <IconButton
            size="small"
            onClick={() => onClose(false)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="p-3" >
        <TextField
          fullWidth
          name="quoteName"
          label="Quote Name"
          variant="outlined"
          value={quoteName}
          onChange={(event) => setQuoteName(event.target.value)}
        />
      </DialogContent>
      <DialogActions className="justify-between">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onClose(false)}
          className="w-120 uppercase"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="uppercase"
          onClick={handleEditName}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditQuoteNameDialog;
